import React from "react"
import {goodUntil, dayLabel} from "../plan"

export default function ListItem({
    checked,
    stocked,
    label,
    categoryClass,
    handleTick,
    handleEdit,
    handleCategoryUp,
    handleCategoryDown,
    handleDelete,
    fromMeal,
    justMade,
    categoryIndex,
    originalIndex,
    plan
  }){
  const styles = {
    "textDecoration": (checked ? "line-through" : ""),
    "color": (stocked ? "#290080" : "#000000")
  }
  let [editMode,setEditMode] = React.useState(justMade)
  let labelDiv = justMade || editMode ?
      <input 
        className="listItem--label"
        style={styles}
        placeholder={label}
        onKeyUp={(e) => handleEdit(e,originalIndex,setEditMode)}
        autoFocus/> 
    : 
      <div className="listItem--label"
      style={styles}
      onClick={enterEditMode}>
      {label}</div>
  const sourceNumber = fromMeal.length
  let mealSources = sourceNumber >= 4 ? (fromMeal.map((meal,index) => {
    if (index > 2) {return null}
    return index !== 2 ? <div className="listItem--mealSource" key={index}>{meal.label}</div> : <div className="listItem--mealSource" key={index}> +{sourceNumber - 2} more</div>
    }
  )) : (fromMeal.map((meal,index) => 
    <div className="listItem--mealSource" key={index}>{meal.label}</div>
  ))
  
  function enterEditMode(){
    if(fromMeal.map((meal) => {return meal.id}).includes("0") && handleEdit != null){
      setEditMode(previousEditMode => !previousEditMode)
    }
  }

  // "Good until" hint (ROADMAP part 3): the latest target day across the
  // meals that use this item. Null when none of the source meals is in the
  // plan (extras-only items never get one).
  const goodUntilDay = goodUntil(plan, fromMeal)


  
  return(
    <div className="listItem">
      <div className="listItem--leftStuff">
      <input 
        className="listItem--tickBox"
        type="checkbox" checked={checked ? "checked" : ""} 
        onChange={() => handleTick(originalIndex)}/>
      {(fromMeal.map((meal) => {return meal.id}).includes("0")) && checked && (handleDelete != null) && <button
        className="listItem--deleteButton"
        onClick={() => handleDelete(originalIndex)}>X
      </button>}
      <div className="listItem--categoryDiv">
        {categoryClass !== "t" && !checked && (handleCategoryUp != null) &&<button
          className="listItem--categoryButton"
          onClick={() => handleCategoryUp(categoryIndex)}>^
        </button>}
        {categoryClass !== "b" && !checked && (handleCategoryDown != null) && <button
          className="listItem--categoryButton"
          onClick={() => handleCategoryDown(categoryIndex)}>v
        </button>}
      </div >
      {labelDiv}
        </div>
        <div className="listItem--rightStuff">
        <div className="listItem--mealSources">
        {mealSources}
        </div>
        {goodUntilDay && <div className="listItem--goodUntil">good until {dayLabel(goodUntilDay)}</div>}
        </div>
    </div>
  )
}